import { render, staticRenderFns } from "./sme-premium-form.vue?vue&type=template&id=388f5c6c&scoped=true&"
import script from "./sme-premium-form.vue?vue&type=script&lang=js&"
export * from "./sme-premium-form.vue?vue&type=script&lang=js&"
import style0 from "./sme-premium-form.vue?vue&type=style&index=0&id=388f5c6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388f5c6c",
  null
  
)

export default component.exports